import * as type from '../../../actions/index.types'

const initialState = {
    reportData: null,
    headColumns: [],
    reportPagination: null,
    loading: false,
    error: null,

    // Aging Report
    agingData: null,
    agingSummary: null,
    agingAsOnDate: null,
    agingPagination: null,
    agingLoading: false,
    agingError: null,

    // Interest Report
    interestData: null,
    interestSummary: null,
    interestPagination: null,
    interestLoading: false,
    interestError: null,

    // Receipt Report
    receiptReportData: null,
    receiptReportSummary: null,
    receiptReportPagination: null,
    receiptReportLoading: false,
    receiptReportError: null,

    // Credit/Debit Note Report
    cdNoteReportData: null,
    cdNoteReportSummary: null,
    cdNoteReportPagination: null,
    cdNoteReportLoading: false,
    cdNoteReportError: null,

    // GST Report
    gstReportData: null,
    gstReportSummary: null,
    gstReportPagination: null,
    gstReportLoading: false,
    gstReportError: null,

    // Reconciliation Report
    reconData: null,
    reconInvoiceTypeCols: [],
    reconSummary: null,
    reconPagination: null,
    reconLoading: false,
    reconError: null,
}

export function InvoiceReportReducer(state = initialState, action) {
    switch (action.type) {
        case type.GET_INVOICE_REPORT:
            return {
                ...state,
                loading: true,
                error: null
            }
        case type.GET_INVOICE_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                reportData: action.payload?.data?.invoices || [],
                headColumns: action.payload?.data?.headColumns || [],
                reportPagination: action.payload?.meta?.pagination || null,
                error: null
            }
        case type.GET_INVOICE_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.message
            }

        case type.GET_INVOICE_AGING_REPORT:
            return {
                ...state,
                agingLoading: true,
                agingError: null
            }
        case type.GET_INVOICE_AGING_REPORT_SUCCESS:
            return {
                ...state,
                agingLoading: false,
                agingData: action.payload?.data?.invoices || [],
                agingSummary: action.payload?.data?.summary || null,
                agingAsOnDate: action.payload?.data?.as_on_date || null,
                agingPagination: action.payload?.meta?.pagination || null,
                agingError: null
            }
        case type.GET_INVOICE_AGING_REPORT_FAILURE:
            return {
                ...state,
                agingLoading: false,
                agingError: action.message
            }

        case type.GET_INTEREST_REPORT:
            return {
                ...state,
                interestLoading: true,
                interestError: null
            }
        case type.GET_INTEREST_REPORT_SUCCESS:
            return {
                ...state,
                interestLoading: false,
                interestData: action.payload?.data?.invoices || [],
                interestSummary: action.payload?.data?.summary || null,
                interestPagination: action.payload?.meta?.pagination || null,
                interestError: null
            }
        case type.GET_INTEREST_REPORT_FAILURE:
            return {
                ...state,
                interestLoading: false,
                interestError: action.message
            }

        case type.GET_RECEIPT_REPORT:
            return { ...state, receiptReportLoading: true, receiptReportError: null }
        case type.GET_RECEIPT_REPORT_SUCCESS:
            return {
                ...state,
                receiptReportLoading: false,
                receiptReportData: action.payload?.data?.receipts || [],
                receiptReportSummary: action.payload?.data?.summary || null,
                receiptReportPagination: action.payload?.meta?.pagination || null,
                receiptReportError: null
            }
        case type.GET_RECEIPT_REPORT_FAILURE:
            return { ...state, receiptReportLoading: false, receiptReportError: action.message }

        case type.GET_CD_NOTE_REPORT:
            return { ...state, cdNoteReportLoading: true, cdNoteReportError: null }
        case type.GET_CD_NOTE_REPORT_SUCCESS:
            return {
                ...state,
                cdNoteReportLoading: false,
                cdNoteReportData: action.payload?.data?.notes || [],
                cdNoteReportSummary: action.payload?.data?.summary || null,
                cdNoteReportPagination: action.payload?.meta?.pagination || null,
                cdNoteReportError: null
            }
        case type.GET_CD_NOTE_REPORT_FAILURE:
            return { ...state, cdNoteReportLoading: false, cdNoteReportError: action.message }

        case type.GET_GST_REPORT:
            return { ...state, gstReportLoading: true, gstReportError: null }
        case type.GET_GST_REPORT_SUCCESS:
            return {
                ...state,
                gstReportLoading: false,
                gstReportData: action.payload?.data?.invoices || [],
                gstReportSummary: action.payload?.data?.summary || null,
                gstReportPagination: action.payload?.meta?.pagination || null,
                gstReportError: null
            }
        case type.GET_GST_REPORT_FAILURE:
            return { ...state, gstReportLoading: false, gstReportError: action.message }

        case type.GET_RECONCILIATION_REPORT:
            return { ...state, reconLoading: true, reconError: null }
        case type.GET_RECONCILIATION_REPORT_SUCCESS:
            return {
                ...state,
                reconLoading: false,
                reconData: action.payload?.data?.flats || [],
                reconInvoiceTypeCols: action.payload?.data?.invoiceTypeColumns || [],
                reconSummary: action.payload?.data?.summary || null,
                reconPagination: action.payload?.meta?.pagination || null,
                reconError: null
            }
        case type.GET_RECONCILIATION_REPORT_FAILURE:
            return { ...state, reconLoading: false, reconError: action.message }

        default:
            return state
    }
}
